import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorProductItemSearch = () => {
  const productItemSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/product/item/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { productItemSearch }
}

export default InteractorProductItemSearch
